import * as React from 'react';

import { IconButton } from '@coursera/cds-core';
import { AIGenerateBrandedNewIcon } from '@coursera/cds-icons';
import { useTracker } from '@coursera/event-pulse/react';

import SparkleOpenIcon from 'bundles/unified-common/components/coach-on-discovery/SparkleOpenIcon';
import { useCoachState } from 'bundles/unified-common/providers/CoachStateProvider';
import { useIsTwoPanelChatRoute } from 'bundles/unified-common/providers/TwoPanelChatRouteProvider';

import _t from 'i18n!nls/composable-page-header';

const TwoPanelChatTriggerGridItem = () => {
  const isTwoPanelChatRoute = useIsTwoPanelChatRoute();
  const { coachOpen, setCoachOpen, contextConfig } = useCoachState();
  const track = useTracker();

  if (!isTwoPanelChatRoute) return null;

  const tooltip = _t('Ask Coursera');

  const handleClick = () => {
    track('interact_coach', {
      coachInteractionType: coachOpen ? 'close_coach_tool' : 'launch_coach_tool',
      coach: {
        mode: contextConfig.config.coachModeId,
        location: 'page_header',
      },
    });
    setCoachOpen((prev) => !prev);
  };

  return (
    <IconButton
      aria-label={tooltip}
      tooltip={tooltip}
      onClick={handleClick}
      data-testid="two-panel-chat-trigger"
      variant="ghost"
      icon={coachOpen ? <SparkleOpenIcon size="large" /> : <AIGenerateBrandedNewIcon size="large" />}
    />
  );
};

export default TwoPanelChatTriggerGridItem;
